"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodashEs = require("lodash-es");
var _CTAList = _interopRequireDefault(require("../../../components/CTAList"));
var _Text = _interopRequireDefault(require("../../../components/Text"));
var _slots = _interopRequireWildcard(require("../../packages/slots"));
var Styled = _interopRequireWildcard(require("./index.styled"));
var _jsxRuntime = require("react/jsx-runtime");
const FilterBar = function (props) {
  const {
    filters,
    clearCta,
    children,
    className
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.FilterBadges, {
    className: className,
    "data-testid": "FilterBar",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_slots.Slot, {
      name: "badges",
      children: filters === null || filters === void 0 ? void 0 : filters.map(function (filter) {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.Badge, {
          "aria-label": `Remove ${filter.label} filter`,
          onClick: filter.handleClick,
          "data-testid": "FilterBar",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
            children: filter.label
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.CloseIcon, {})]
        }, filter.label);
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_slots.Slot, {
      name: "cta",
      children: clearCta && !(0, _lodashEs.isEmpty)(filters) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CTAList.default, {
        ctas: [clearCta]
      })
    }), children]
  });
};
var _default = exports.default = (0, _slots.default)(FilterBar);